import { render, staticRenderFns } from "./DraggableGuest.vue?vue&type=template&id=6ea2b80c"
import script from "./DraggableGuest.vue?vue&type=script&lang=js"
export * from "./DraggableGuest.vue?vue&type=script&lang=js"
import style0 from "./DraggableGuest.vue?vue&type=style&index=0&id=6ea2b80c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports